import { PopupEvent } from '@/services/act/PopupController'
import { getActConfig } from '@/api/act'
import { BasePopupScript } from './BasePopupScript'
import cookies from 'js-cookie'
import client from '@/client/'

const remoteConfigKey = 'retain_red_bag_activity'
const expires = 100
const activityShowKey = 'activityShowKey'

export class RetainUsers extends BasePopupScript {
  /**
   * @type { { activityName:string, title:string, content:string, buttonText:string, interval: number } }
   */
  _config = {}

  /** 弹出时间间隔 单位天数 */
  interval = -1

  /** 是否会员 */
  isMember = false

  /** 用户openid */
  openId = 0

  /** tid1限制列表 */
  tidList = []

  constructor () {
    super(PopupEvent.retainUsersEvent)
  }

  /**
   * 控制弹出条件
   * 非会员弹出
   * 用户openId最后一位数为奇数弹出
   * 七天内未弹出过弹泡用户
   * @returns {Promise<boolean>}
   */
  async valid () {
    if (this.interval < 0 || this.tidList.length === 0) {
      await this._updateRemoteConfig()
    }
    this._report()

    if (this._tidCondition()) {
      return false
    }

    if (this.isMember || this._isOpenIdScope()) {
      return false
    }

    if (!this._isShowIntervalValid()) {
      return false
    }

    return true
  }

  updateData (route, store) {
    const { isMember, isPdfLifeMember, isPdfMember, loginStatus, openId } = store.getters
    this.isMember = isMember || isPdfLifeMember || isPdfMember || !loginStatus
    this.openId = openId || 0
  }

  reset () { }

  /**
   * 获取活动配置
   * @returns {{interval:number,activityName:string,title:string,content:string,buttonText:string}}
   */
  getActivityConfig () {
    return new Promise((resolve, reject) => {
      resolve(this._config)
    })
  }

  setHasShowTag () {
    this._setShowTimeCache()
  }

  _report () {
    const abtest = this._isOpenIdScope() ? 2 : 1
    client.retainUsers.REPORT.reportQuitRetainUsers({ abtest })
  }

  async _updateRemoteConfig () {
    const res = await getActConfig({ type: remoteConfigKey })

    if (res && res.resp_common && res.resp_common.ret === 0) {
      this._config = res[remoteConfigKey] || this._config
      this.interval = this._config.interval
      this.tidList = this._config.tid1_list || []
    }
  }

  /**
   * 根据openid最后一个数判断。 0 ~ 9打开
   * @returns {boolean}
   */
  _isOpenIdScope () {
    const openId = String(this.openId)
    const num = openId[openId.length - 1] || 0

    return !(num <= 9 && num >= 0)
  }

  /**
   * tid条件限制
   * @returns { boolean }
   */
  _tidCondition () {
    const { tid1 = 0 } = window.app.$TidObj

    return !this.tidList.includes(+tid1)
  }

  _isShowIntervalValid () {
    const lastShowTime = this._getShowTimeCache()
    const currentShowTime = new Date().getTime()
    const milliseconds = currentShowTime - lastShowTime
    const day = Math.floor(milliseconds / 1000 / 3600 / 24)

    return day >= this.interval
  }

  /**
   * 返回上次展示的时间戳，没有则返回 0
   * @returns {number}
   */
  _getShowTimeCache () {
    const value = cookies.get(activityShowKey)
    const defaultRes = 0
    const num = parseInt(value)

    if (!value || isNaN(num)) {
      return defaultRes
    }

    return num
  }

  _setShowTimeCache () {
    const timeStamp = new Date()
    cookies.set(activityShowKey, timeStamp.getTime().toString(), { expires })
  }
}
